// dependencies
import { List, Map, fromJS } from "immutable";

export const getReviewCycle = (state, cycleID, notSetValue = null) =>
	state.reviewCycles.getIn(["cycles", cycleID], notSetValue);

/** Get the list of forms across a review cycle */
export const getAllReviewCycleForms = (state, cycleID) => {
	const cycle = getReviewCycle(state, cycleID, Map());
	const allForms = {
		basicForms: cycle.get("basicForms", List()),
		externalForms: cycle.get("externalForms", List()),
		easyAddForms: cycle.get("easyAddForms", List()),
	};
	return fromJS(allForms);
};

/** Searches the review cycle forms for the given form name */
export const getReviewCycleFormByName = (state, cycleID, formName, notSetValue = null) => {
	const allForms = getAllReviewCycleForms(state, cycleID);
	const forms = List([
		...allForms.get("basicForms"),
		...allForms.get("externalForms"),
		...allForms.get("easyAddForms"),
	]);
	return forms.find((form) => form.get("name") === formName, null, notSetValue);
};
